import React from 'react';
import styled from '@emotion/styled';
import { Twitter, Linkedin } from '@styled-icons/fa-brands';
import { RssSquare } from '@styled-icons/fa-solid';
import PropTypes from 'prop-types';

const Wrapper = styled.header`
  h1 {
    margin-top: 0;
  }
  a {
    color: ${props => props.theme.colors.link.base};
  }
  a:hover {
    color: ${props => props.theme.colors.link.hover};
  }
  a {
    padding-right: 10px;
  }
  .meta-data {
    float: left;
    clear: none;
    margin-top: 25px;
    color: ${props => props.theme.colors.gray.dark};
    line-height:1.5rem;
  }
  .clearfix::after {
    display: block;
    clear: both;
    content: "";
  }
  .authorIcon {
    width: 80px;
    height: 80px;
    float: left;
    margin: 15px 15px 30px 0;
    border-radius: 50%;
    box-shadow: none;
  }
  .socialIcon {
    width: 14px;
    vertical-align: middle;
  }
  .badge {
    background: ${props => props.theme.colors.gray.dark};
    margin-right: 10px;
  }
  @media (max-width: ${props => props.theme.breakpoints.xxl}) {
    .authorIcon {
      width: 65px;
      height: 65px;
    }
  }
`;

const ArticleHeader = ({ children, path, title, subtitle, date, author, authorImage, readtime, cover }) => (
  <Wrapper>
    <div className='clearfix'>
      <h1>{title}</h1>
      {subtitle && <h3>{subtitle}</h3>}
      <img src={authorImage} className='authorIcon' alt={author} />
      <p className='meta-data'>
        {author} | <em>{date}</em> | {readtime}
        <br />
        Share this: &nbsp;&nbsp;
        <a href={`https://twitter.com/intent/tweet?text=${title}&url=https://stackery.io/blog/${path}`} target='_blank' rel='noopener noreferrer' title='Share on Twitter'>
          <Twitter className='socialIcon' />
        </a>
        <a href={`http://www.linkedin.com/shareArticle?mini=true&url=https://stackery.io/blog/${path}&title=${title}&source=https://stackery.io/`} target='_blank' rel='noopener noreferrer' title='Share on LinkedIn'>
          <Linkedin className='socialIcon' />
        </a>
        <a href='https://www.stackery.io/rss.xml' target='_blank' rel='noopener noreferrer' title='Share RSS feed'>
          <RssSquare className='socialIcon' />
        </a>
      </p>
    </div>
  </Wrapper>
);

export default ArticleHeader;

ArticleHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  cover: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.bool]),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  readtime: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.bool
  ]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  author: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  authorImage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  path: PropTypes.string
};

ArticleHeader.defaultProps = {
  children: false,
  cover: false,
  date: false,
  readtime: false,
  title: false,
  subtitle: false,
  author: false,
  authorImage: false
};
